export const roleMap = {
  9: "项目lead",
  10: "架构",
  11: "硬件",
  12: "验证",
  13: "软件",
  14: "后端工程师",
};
